module.exports = __webpack_public_path__ + "lod.d3973300.png";